import api from './api';
import { SubscriptionStatus, PricingResponse } from '../types';

export const getSubscriptionStatus = async (): Promise<SubscriptionStatus> => {
  const response = await api.get('/subscriptions/status');
  return response.data;
};

export const createCheckoutSession = async (tier: 'starter' | 'professional', billingInterval: 'monthly' | 'annual' = 'monthly'): Promise<{ url: string }> => {
  const response = await api.post('/subscriptions/checkout', { tier, billingInterval });
  return response.data;
};

export const validatePortalUrl = (value: unknown): string => {
  if (typeof value !== 'string' || !value.trim()) throw new Error('Invalid billing portal URL');
  const url = new URL(value);
  if (url.protocol !== 'https:' || url.hostname !== 'billing.stripe.com' ||
      url.username || url.password || url.port || !url.pathname.startsWith('/p/session/')) {
    throw new Error('Invalid billing portal URL');
  }
  return url.href;
};

export const createPortalSession = async (): Promise<{ url: string }> => {
  const response = await api.post('/subscriptions/portal');
  return { url: validatePortalUrl(response.data?.url) };
};

export const getPricing = async (): Promise<PricingResponse> => {
  const response = await api.get('/subscriptions/pricing');
  return response.data;
};

export const startTrial = async (tier: 'starter' | 'professional', billingInterval: 'monthly' | 'annual' = 'monthly'): Promise<{ url: string }> => {
  const response = await api.post('/subscriptions/start-trial', { tier, billingInterval });
  return response.data;
};

export interface ScheduledChangeResult {
  pendingTier: 'free' | 'starter' | null;
  pendingChangeAt: string | null;
  cancelAtPeriodEnd: boolean;
}

export const scheduleSubscriptionChange = async (
  targetTier: 'free' | 'starter',
): Promise<ScheduledChangeResult> => {
  const response = await api.post('/subscriptions/schedule-change', { targetTier });
  return response.data;
};

export const revertScheduledSubscriptionChange = async (): Promise<ScheduledChangeResult> => {
  const response = await api.post('/subscriptions/revert-scheduled-change');
  return response.data;
};
